// types
import {
  IAllNetworkStats,
  IAllNetworkLocationStats,
  INetworkTrendsData,
  NetworkTrendsPeriod,
  ITopShareholdersResponse,
} from "./types";
import { rootApi } from "../rootApi";

// Network Stats Api
export const allNetworkStatsApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * GET Network Stats
     * */
    getAllNetworkStats: builder.query<IAllNetworkStats, void>({
      query: () => ({
        url: `company-network/stats/`,
        method: "GET",
      }),
    }),
    /**
     * GET Network Location Stats
     * */
    getAllNetworkLocationStats: builder.query<IAllNetworkLocationStats, void>({
      query: () => ({
        url: `company-network/location-stats/`,
        method: "GET",
      }),
    }),
    /**
     * GET Network Trends
     * */
    getNetworkTrends: builder.query<INetworkTrendsData, NetworkTrendsPeriod>({
      query: (period) => ({
        url: `company-network/trends/`,
        method: "GET",
        params: { period },
      }),
    }),
    /**
     * GET Top Shareholders
     * */
    getTopShareholders: builder.query<
      ITopShareholdersResponse,
      { page: number }
    >({
      query: ({ page }) => ({
        url: `company-network/top-customers/`,
        method: "GET",
        params: { page },
      }),
    }),
  }),
});

export const {
  useGetAllNetworkStatsQuery,
  useGetAllNetworkLocationStatsQuery,
  useGetNetworkTrendsQuery,
  useGetTopShareholdersQuery,
} = allNetworkStatsApi;
